import React from 'react';
import './App.css';
import Main from './Components/Main';

function App() {
  return (
    <React.Fragment>
      <Main />
    </React.Fragment>
  );
}

export default App;
